import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import tariffReducer from './slices/tariffSlice';
import driverCreditReducer from './slices/driverCreditSlice';

// ROOT REDUCER
const rootReducer = combineReducers({
  tariff: tariffReducer,
  driverCredit: driverCreditReducer,
  _stub: (state = {}) => state
});

const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['auth'], // Only persist these slices
  // blacklist: ['_stub'], // Don't persist stub
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
